export function isStringEmptyOrWhitespace(str: string | undefined): boolean {
    return !str || str.trim() === '';
}
